export enum LOCK_ACTION {
  UNKNOWN = 0,
  ERROR = 1,
  REQUEST = 2,
  RESPONSE = 3,
  RELEASE = 4,
}
